export default "__VITE_ASSET__BeY0Ir6K__"